export const SELECT_MENU = 'SELECT_MENU';
export const HANDLE_CHANGE = 'HANDLE_CHANGE';
export const SELECT_PLAN = 'SELECT_PLAN';
export const LOGIN = 'LOGIN';
export const LOADING = 'LOADING';
export const LOAD_CITIES = 'LOAD_CITIES';
export const LOAD_MODEL = 'LOAD_MODEL';
export const SUM_ASSURED = 'SUM_ASSURED';
export const RESET = 'RESET';
export const RESET_CITIES = 'RESET_CITIES';
export const POST_DATA = 'POST_DATA';
export const POST_DATA_MENU = 'POST_DATA_MENU';
export const SEARCH_COTIZACION = 'SEARCH_COTIZACION';
export const INFO_USER = 'INFO_USER';
export const CONFIRM_CODE = 'CONFIRM_CODE';
export const UPDATE_INFO_USER = 'UPDATE_INFO_USER';
export const SET_POL = 'SET_POL'
/* -- ADMIN -- */
export const GET_POLICY = "GET_POLICY";
export const UPDATE_POLICY = "UPDATE_POLICY";
export const GET_POLICIES = "GET_POLICIES";
export const ADMIN_CHANGE = "ADMIN_CHANGE";
export const GET_STATICS = "GET_STATICS";
export const RESET_STATICS = "RESET_STATICS";
export const SET_POLIZA = "SET_POLIZA";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_POL_FILTERS = "SET_POL_FILTERS";
export const SET_CODEMP = "SET_CODEMP";
export const CHANGE_LAST_STATE = "CHANGE_LAST_STATE";

export const UPDATE_INFO_USERS = 'UPDATE_INFO_USERS';
export const UPDATE_INFO_SUCURSALES = 'UPDATE_INFO_SUCURSALES';
export const UPDATE_INFO_REGIONS = 'UPDATE_INFO_REGIONS';
export const UPDATE_INFO_ZONES = 'UPDATE_INFO_ZONES';
export const ALERT_DATA = 'ALERT_DATA';

export const GLOBAL_SHOW = 'GLOBAL_SHOW';

export const SET_SIN_FILTERS = 'SET_SIN_FILTERS';
export const SET_SIN = 'SET_SIN';
export const DELETE_SINISTER = 'DELETE_SINISTER';

export const ERROR_BACK = 'ERROR_BACK';
export const SET_WAITING_CITIES = 'SET_WAITING_CITIES';

